import { Injectable }    from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Headers, Http } from '@angular/http';
import * as CryptoJS from 'crypto-js';  

import 'rxjs/add/operator/toPromise';
import Constants from '../constants/Constants';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'
import * as util from '../util/index'

@Injectable()
export class EmployeeService {

    private baseEmployeeUrl = "/Employee";  // URL to web api
    private getEmployeesURL = '';
    private getEmployeesLiteURL = '';
    private getSalesOfficeApproversURL = '';
    private saveEmployeeURL = '';
    private saveEmployeeFeaturesURL = '';
    private saveSalesOfficeApproverURL = '';
    private getEmployeeActivationRequestsURL = '';
    private saveEmployeeActivationRequestURL = '';
    private changePasswordURL = '';
    private changePhoneNumberURL = '';

    keySize: number = 256;
    ivSize: number = 128;
    saltSize: number = 256;
    iterations: number = 1000;

    appConfig: ent.AppConfig;

    constructor(private http: Http, private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseEmployeeUrl = this.configService.appConfig.UrlBase + this.baseEmployeeUrl;

        this.getEmployeesURL = this.baseEmployeeUrl + '/GetEmployees';
        this.getEmployeesLiteURL = this.baseEmployeeUrl + '/GetEmployeesLite';
        this.getSalesOfficeApproversURL = this.baseEmployeeUrl + '/GetSalesOfficeApprovers';
        this.saveEmployeeURL = this.baseEmployeeUrl + '/SaveEmployee';
        this.saveEmployeeFeaturesURL = this.baseEmployeeUrl + '/SaveEmployeeFeatures';
        this.saveSalesOfficeApproverURL = this.baseEmployeeUrl + '/SaveSalesOfficeApprover';
        this.getEmployeeActivationRequestsURL = this.baseEmployeeUrl + '/GetEmployeeActivationRequests';
        this.saveEmployeeActivationRequestURL = this.baseEmployeeUrl + '/SaveEmployeeActivationRequest';
        this.changePasswordURL = this.baseEmployeeUrl + '/ChangePassword';
        this.changePhoneNumberURL = this.baseEmployeeUrl + '/ChangePhoneNumber';
    }

    // getEmployees(filter: filters.EmployeeFilter): Promise<ent.Employee[]> {
    //     return this.http.post(this.getEmployeesURL, filter)
    //             .toPromise()
    //             .then(response => response.json() as ent.Employee[])
    //             .catch(this.handleError);
    // }

    // getEmployees(filter: filters.EmployeeFilter): Promise<ent.Employee[]> {
    //     return this.http.post(this.getEmployeesURL, filter)
    //             .toPromise()
    //             .then(response => {
    //                 var encUtil: util.EncryptionUtil = new util.EncryptionUtil();
    //                 var decrypted = encUtil.decrypt(response.text(), Constants._ENCRYPTION_PASSWORD);
    //                 return JSON.parse(decrypted);
    //             })
    //             .catch(this.handleError);
    // }

    getEmployees(filter: filters.EmployeeFilter): Observable<ent.Employee[]> {
      return this.httpClient.post<ent.Employee[]>(this.getEmployeesURL, filter);
    }

    // getEmployeesLite(): Promise<ent.Employee[]> {
    //     return this.http.get(this.getEmployeesLiteURL)
    //             .toPromise()
    //             .then(response => response.json() as ent.Employee[])
    //             .catch(this.handleError);
    // }

    // getEmployeesLite(): Promise<ent.Employee[]> {
    //     return this.http.get(this.getEmployeesLiteURL)
    //         .toPromise()
    //         .then(response => {
    //             var encUtil: util.EncryptionUtil = new util.EncryptionUtil();
    //             var decrypted = encUtil.decrypt(response.text(), Constants._ENCRYPTION_PASSWORD);
    //             return JSON.parse(decrypted);
    //         })
    //         .catch(this.handleError);
    // }

    getEmployeesLite(): Observable<ent.Employee[]> {
      return this.httpClient.get<ent.Employee[]>(this.getEmployeesLiteURL);
    }

    // encrypt(msg: string, pass: string) {
    //     var salt = CryptoJS.lib.WordArray.random(this.saltSize / 8);
    
    //     var key = CryptoJS.PBKDF2(pass, salt, {
    //       keySize: this.keySize / 32,
    //       iterations: this.iterations,
    //     });
    
    //     var iv = CryptoJS.lib.WordArray.random(this.ivSize / 8);
    
    //     var encrypted = CryptoJS.AES.encrypt(msg, key, {
    //       iv: iv,
    //       padding: CryptoJS.pad.Pkcs7,
    //       mode: CryptoJS.mode.CBC,
    //     });
    
    //     var encryptedHex = this.base64ToHex(encrypted.toString());
    //     var base64result = this.hexToBase64(salt + iv + encryptedHex);
    
    //     return base64result;
    //   }
    
      decrypt(transitmessage: any, pass: any) {
        var hexResult = this.base64ToHex(transitmessage);
    
        var salt = CryptoJS.enc.Hex.parse(hexResult.substr(0, 64));
        var iv = CryptoJS.enc.Hex.parse(hexResult.substr(64, 32));
        var encrypted = this.hexToBase64(hexResult.substring(96));
    
        var key = CryptoJS.PBKDF2(pass, salt, {
          keySize: this.keySize / 32,
          iterations: this.iterations,
        });
    
        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
          iv: iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC,
        });
    
        return decrypted.toString(CryptoJS.enc.Utf8);
      }
    
      hexToBase64_nogood(str: any) {
        
        return btoa(
          String.fromCharCode.apply(
            null,
            str
              .replace(/\r|\n/g, '')
              .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
              .replace(/ +$/, '')
              .split(' ')
          )
        );
      }

      hexToBase64( buffer: any ) {
        buffer = buffer
              .replace(/\r|\n/g, '')
              .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
              .replace(/ +$/, '')
              .split(' ')
        
        var binary = '';
        var bytes = new Uint8Array( buffer );
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
        }
        return window.btoa( binary );
      }
    
      base64ToHex(str: any) {
        str = str.replace(/"/g, '');
        for (
          var i = 0, bin = atob(str.replace(/[ \r\n]+$/, '')), hex = [];
          i < bin.length;
          ++i
        ) {
          var tmp = bin.charCodeAt(i).toString(16);
          if (tmp.length === 1) tmp = '0' + tmp;
          hex[hex.length] = tmp;
        }
        return hex.join('');
      }

      getSalesOfficeApprovers(): Observable<ent.SalesOfficeApprover[]> {
        return this.httpClient.get<ent.SalesOfficeApprover[]>(this.getSalesOfficeApproversURL);
      }

   

      getEmployeesFromCache(): ent.Employee[] {
        var cachedData: any = JSON.parse(localStorage.getItem('employees'));
        var items = cachedData.x;
        var results: ent.Employee[] = [];
        for (var i = 0; i < items.length; i++){
            var item = items[i] as ent.Employee;
            results.push(item);
        }
        return results;

    }

    saveEmployee(saveEmployeeRequest: ent.SaveEmployeeRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveEmployeeURL, saveEmployeeRequest);
    }

    saveEmployeeFeatures(saveRequest: ent.EmployeeFeaturesSaveRequest): Observable<ent.Response> {
      return this.httpClient.post<ent.Response>(this.saveEmployeeFeaturesURL, saveRequest);
    }

    getEmployeeActivationRequests(): Observable<ent.EmployeeActivationRequest[]> {
      return this.httpClient.get<ent.EmployeeActivationRequest[]>(this.getEmployeeActivationRequestsURL);
    }

    saveEmployeeActivationRequest(record: ent.EmployeeActivationRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveEmployeeActivationRequestURL, record);
    }
    
    saveSalesOfficeApprover(saveRequest: ent.SaveSalesOfficeApproverRequest): Observable<ent.Response> {
      return this.httpClient.post<ent.Response>(this.saveSalesOfficeApproverURL, saveRequest);
    }

    changePassword(changePasswordRequest: ent.ChangePasswordRequest): Observable<ent.Response> {
      return this.httpClient.post<ent.Response>(this.changePasswordURL, changePasswordRequest);
    }

    changePhoneNumber(request: ent.ChangePhoneNumberRequest): Observable<ent.Response> {
      return this.httpClient.post<ent.Response>(this.changePhoneNumberURL, request);
    }

    private handleError(error: any): Promise<any> {
      console.error('An error occurred', error); // for demo purposes only
      return Promise.reject(error.message || error);
    }

    
}
